/* Intimo Makeup · landing del taller de automaquillaje.
   Datos del taller en un solo lugar: si cambia la fecha o el precio, se cambia aquí y en el HTML. */
(function () {
  const C = {
    wa: ["1809", "753", "8567"].join(""), // partido para que los bots no lo encuentren en el código
    taller: "Taller de Automaquillaje del domingo 13 de diciembre (2:00 a 6:00 PM)",
    price: 6000, deposit: 2000, seats: 20, maxPerForm: 6,
    pixel: "1121308720910339", // Meta Pixel de Intimo Makeup
    // API de conversiones: webhook de Make que reenvía el Lead a Meta desde el servidor
    capiHook: "https://hook.us2.make.com/u6rigo5gk15iwottsggchfvvidjyhviu"
  };
  const rd = v => "RD$" + v.toLocaleString("en-US");
  const $ = id => document.getElementById(id);

  /* ---------- seguimiento ---------- */
  if (C.pixel) {
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s) }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", C.pixel); fbq("track", "PageView");
  }
  function track(ev, data, std, eventID) {
    try {
      const opt = eventID ? { eventID } : undefined;
      if (window.fbq) std ? fbq("track", ev, data || {}, opt) : fbq("trackCustom", ev, data || {}, opt);
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("intimo_" + ev.toLowerCase(), data || {});
    } catch (e) {}
  }

  /* fbclid del anuncio: se guarda al entrar para armar el fbc aunque la persona navegue */
  const FBCLID = (() => {
    try {
      const id = new URLSearchParams(location.search).get("fbclid");
      if (id) { const v = `fb.1.${Date.now()}.${id}`; localStorage.setItem("im_fbc", v); return v; }
      return localStorage.getItem("im_fbc") || "";
    } catch (e) { return ""; }
  })();
  const cookie = n => { try { const m = document.cookie.match("(?:^|; )" + n + "=([^;]*)"); return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return ""; } };
  async function sha256(t) {
    const b = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
    return [...new Uint8Array(b)].map(x => x.toString(16).padStart(2, "0")).join("");
  }

  /* Lead por servidor (API de conversiones). Teléfono y nombre salen ya cifrados. Mismo event_id que el Pixel para no contar doble */
  async function sendCapi(eventID, tel, nombre, data, sheet) {
    if (!C.capiHook || !window.crypto || !crypto.subtle) return;
    try {
      const ud = { client_user_agent: navigator.userAgent, country: [await sha256("do")], ph: [await sha256("1" + tel)] };
      const fn = nombre.split(/\s+/)[0].toLowerCase();
      if (fn) ud.fn = [await sha256(fn)];
      const fbc = cookie("_fbc") || FBCLID, fbp = cookie("_fbp");
      if (fbc) ud.fbc = fbc;
      if (fbp) ud.fbp = fbp;
      const event = {
        event_name: "Lead", event_time: Math.floor(Date.now() / 1000), event_id: eventID,
        action_source: "website", event_source_url: location.origin + location.pathname, user_data: ud, custom_data: data
      };
      const body = new URLSearchParams({ event: JSON.stringify(event) });
      Object.entries(sheet).forEach(([k, v]) => body.append("l_" + k, v ?? ""));   // fila legible por si luego se guarda en una hoja
      if (!(navigator.sendBeacon && navigator.sendBeacon(C.capiHook, body)))
        fetch(C.capiHook, { method: "POST", body, mode: "no-cors", keepalive: true });
    } catch (e) {}
  }

  /* ---------- VSL ---------- */
  /* Un clip corto arranca solo y en silencio; mientras la persona lee, el video completo se descarga por detrás.
     Al tocar el aviso se cambia al video completo, con sonido y desde el inicio.
     La barra avanza rápido al principio y más lento al final (curva 1-(1-x)^2.5) para que el video se sienta corto. */
  const v = $("vslv"), box = $("vsl"), vbar = $("vslbar"), prev = box.querySelector(".vprev");
  let live = false;
  const net = navigator.connection || {};
  const slow = net.saveData || /(^|-)2g$/.test(net.effectiveType || "");
  if (slow) {   // datos lentos o modo ahorro: ni clip ni descarga previa, solo la portada con el botón
    if (prev) { prev.removeAttribute("autoplay"); prev.preload = "none"; prev.removeAttribute("src"); prev.load(); }
    const b = box.querySelector(".unmute b"), sp = box.querySelector(".unmute span");
    if (b) b.textContent = "Mira el video"; if (sp) sp.textContent = "Toca para verlo con sonido";
  } else {
    if (prev) prev.play().catch(() => {});   // si el navegador bloquea el autoplay, el aviso igual sirve de botón de play
    const preload = () => { if (!live) { v.preload = "auto"; v.load(); } };
    if (document.readyState === "complete") setTimeout(preload, 800);
    else addEventListener("load", () => setTimeout(preload, 800), { once: true });
  }
  $("vslbtn").addEventListener("click", () => {
    live = true; v.muted = false; v.play();
    if (prev) prev.pause();
    box.classList.add("live", "playing"); box.classList.remove("stopped");
    track("ViewContent", { content_name: "VSL taller" }, true);
    if (vbar) requestAnimationFrame(drawBar);
  });
  v.addEventListener("click", () => {
    if (!live) return;
    if (v.paused) { v.play(); box.classList.remove("stopped"); } else { v.pause(); box.classList.add("stopped"); }
  });
  function drawBar() {
    if (v.duration) vbar.style.width = (100 * (1 - Math.pow(1 - v.currentTime / v.duration, 2.5))).toFixed(2) + "%";
    if (!v.ended) requestAnimationFrame(drawBar);
  }
  v.addEventListener("ended", () => {
    if (!live) return;
    if (vbar) vbar.style.width = "100%";
    const t = $("reservar"); t && t.scrollIntoView({ behavior: "smooth" });
  });

  /* ---------- cupos ---------- */
  const dots = $("dots");
  if (dots) dots.innerHTML = "<i></i>".repeat(C.seats);
  let n = 1, started = false;
  const out = $("n"), sum = $("sum");
  function draw() {
    out.textContent = n;
    sum.innerHTML =
      `<div><span>${n} cupo${n > 1 ? "s" : ""} × ${rd(C.price)}</span><span>${rd(n * C.price)}</span></div>` +
      `<div class="t"><span>Separas hoy con</span><span>${rd(n * C.deposit)}</span></div>`;
  }
  function start() { if (!started) { started = true; track("InitiateCheckout", { value: C.deposit, currency: "DOP" }, true); } }
  $("minus").onclick = () => { if (n > 1) { n--; draw(); start(); } };
  $("plus").onclick = () => { if (n < C.maxPerForm) { n++; draw(); start(); } };
  document.querySelectorAll("#form input").forEach(i => i.addEventListener("focus", start, { once: true }));
  draw();

  document.querySelectorAll("[data-go]").forEach(a => a.addEventListener("click", () => track("Click_Reservar", { desde: a.dataset.go })));

  /* ---------- envío ---------- */
  $("form").addEventListener("submit", e => {
    e.preventDefault();
    const nombre = $("nombre").value.trim();
    const tel = $("tel").value.replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "");
    const pago = (document.querySelector('input[name="pago"]:checked') || {}).value || "";
    const okP = !!pago, okN = nombre.length >= 2, okT = /^(809|829|849)\d{7}$/.test(tel);
    $("e-pago").style.display = okP ? "none" : "block";
    $("e-nombre").style.display = okN ? "none" : "block";
    $("e-tel").style.display = okT ? "none" : "block";
    if (!okP) return $("pago").scrollIntoView({ behavior: "smooth", block: "center" });
    if (!okN) return $("nombre").focus();
    if (!okT) return $("tel").focus();

    const total = n * C.price, dep = n * C.deposit;
    const msg = [
      `Hola Intimo Makeup 💄 quiero reservar para el ${C.taller}.`,
      ``,
      `• Nombre: ${nombre}`,
      `• Cupos: ${n}`,
      `• Pago: ${pago}`,
      `• Total: ${rd(total)} · separo con ${rd(dep)}`,
      ``,
      `¿Cómo hago el depósito?`
    ].filter(l => l !== null).join("\n");

    const lead = { value: dep, currency: "DOP", num_items: n, content_name: "Taller automaquillaje 13 dic" };
    const eventID = "im-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    track("Lead", lead, true, eventID);
    sendCapi(eventID, tel, nombre, lead, { fecha: new Date().toLocaleString("es-DO"), nombre, whatsapp: tel, cupos: n, pago, total, deposito: dep });
    const url = `https://wa.me/${C.wa}?text=${encodeURIComponent(msg)}`;
    setTimeout(() => { location.href = url; }, 250);
  });

  /* ---------- barra fija: visible cuando el formulario no está en pantalla ---------- */
  const bar = $("bar"), form = $("form"), hero = $("inicio");
  if ("IntersectionObserver" in window) {
    let inForm = false, inHero = true;
    const upd = () => bar.classList.toggle("on", !inForm && !inHero);
    new IntersectionObserver(es => { inForm = es[0].isIntersecting; upd(); }, { threshold: 0 }).observe(form);
    new IntersectionObserver(es => { inHero = es[0].isIntersecting; upd(); }, { threshold: 0.35 }).observe(hero);
  }
})();
